import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import PeopleIcon from "./../../assets/images/informativewall/people.gif";
import HandIcon from "./../../assets/images/informativewall/hand.gif";
import SecureIcon from "./../../assets/images/informativewall/secure.gif";
import TransferIcon from "./../../assets/images/informativewall/transfer.gif";
const InformativeWall = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-4 w-10/12 gap-3 mx-auto mt-6 mb-8 opensans">
        <div className="flex flex-col items-center justify-start gap-3 text-center bg-stone-200 rounded-3xl py-6 px-4">
          <img src={SecureIcon} alt="icono" className="w-16" />
          <div className="text-lg font-normal">
            <div>
              {t("informativewall.more")}{" "}
              <CountUp
                start={0}
                duration={13}
                enableScrollSpy={true}
                end={8000}
                delay={0}
              >
                {({ countUpRef }) => (
                  <span
                    className="font-extrabold text-green-admin-dark"
                    ref={countUpRef}
                  ></span>
                )}
              </CountUp>{" "}
              <span className="font-semibold">
                {t("informativewall.transfersOne")}
              </span>{" "}
              {t("informativewall.transfersTwo")}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-start gap-3 text-center bg-stone-200 rounded-3xl py-6 px-4">
          <img src={PeopleIcon} alt="icono" className="w-16" />
          <div className="text-lg font-normal">
            <div>
              {t("informativewall.more")}{" "}
              <CountUp
                start={0}
                duration={13}
                enableScrollSpy={true}
                end={6000}
                delay={0}
              >
                {({ countUpRef }) => (
                  <span
                    className="font-extrabold text-green-admin-dark"
                    ref={countUpRef}
                  ></span>
                )}
              </CountUp>{" "}
              <span className="font-semibold">
                {t("informativewall.customersOne")}
              </span>{" "}
              {t("informativewall.customersTwo")}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-start gap-3 text-center bg-stone-200 rounded-3xl py-6 px-4">
          <img src={HandIcon} alt="icono" className="w-16" />
          <div className="text-lg font-normal">
            <div>
              {t("informativewall.more")}{" "}
               <span className="font-extrabold text-green-admin-dark">
               {t("informativewall.brokersOne")}
               </span>{' '}

              {t("informativewall.brokersTwo")}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-start gap-3 text-center bg-stone-200 rounded-3xl py-6 px-4">
          <img src={TransferIcon} alt="icono" className="w-16" />
          <div className="text-lg font-normal">
            <div>
              {t("informativewall.more")}{" "}
              <span className="font-black text-green-admin-dark">
                {new Date().getFullYear() - 2014} {t("informativewall.expOne")}
              </span>{" "}
              {t("informativewall.expTwo")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InformativeWall;
